import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import {
  TextFieldHookForm,
  SelectHookForm,
  AutocompleteHookFormAsync,
  LoadingOverlay,
  Button,
  PlusIcon,
  FormContainerControlled,
} from "components";
import { DeptTypeOptions } from "services";
import { i18n } from "translations";
import { loadOrgId, rem } from "utils";

import { useDepartmentDialog } from "./hook";

interface Props {
  show: boolean;
  onToggle: () => void;
  isEdit: boolean;
}

const DepartmentDialog = (props: Props) => {
  const { show = false, isEdit, onToggle = () => {} } = props;
  const { nodeSelected, loading, methods, handleSubmit } = useDepartmentDialog({
    isEdit,
    onToggle,
  });
  return (
    <Dialog open={show} onClose={onToggle} fullWidth>
      <FormContainerControlled methods={methods} onSubmit={handleSubmit}>
        <LoadingOverlay loading={loading} noPadding noBgColor>
          <DialogTitle>
            {isEdit ? i18n.t("updateNode") : i18n.t("addNode")} (
            {nodeSelected?.name || ""})
          </DialogTitle>
          <DialogContent>
            <Stack rowGap={rem(16)} pt={2}>
              <TextFieldHookForm
                name="name"
                label={i18n.t("name")}
                placeholder={i18n.t("typeName")}
                required
              />
              <TextFieldHookForm
                name="code"
                label={i18n.t("code")}
                placeholder={i18n.t("typeCode")}
                required
              />
              <TextFieldHookForm
                name="costCenterCode"
                label={i18n.t("costCenterCode")}
                placeholder={i18n.t("typeCostCenterCode")}
              />
              <TextFieldHookForm
                name="deptCode"
                label={i18n.t("deptCode")}
                placeholder={i18n.t("deptCode")}
              />
              <SelectHookForm
                name="deptType"
                label={i18n.t("type")}
                placeholder={i18n.t("selectType")}
                options={DeptTypeOptions}
                required
              />
              <AutocompleteHookFormAsync
                name="branch"
                label={i18n.t("branch")}
                placeholder={i18n.t("selectBranch")}
                model="branch"
                depField={loadOrgId() as never}
                useDepField
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={onToggle} variant="text" size="sm" useTypography>
              {i18n.t("cancel")}
            </Button>
            <Button
              variant="contained"
              type="submit"
              size="sm"
              startIcon={<PlusIcon fontSize="small" />}
              useTypography
            >
              {isEdit ? i18n.t("save") : i18n.t("create")}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </FormContainerControlled>
    </Dialog>
  );
};

export default DepartmentDialog;
